// Visar vad som händer med en befintlig post när nya uppgifter läggs på:
// tomma fält fylls i, avvikande värden får användaren välja mellan.
import React from 'react';
import { Box, Typography, Radio, RadioGroup, FormControlLabel } from '@mui/material';

/**
 * @param {Array}    rows      från mergePlan(): { key, label, kind, current?, next }
 * @param {object}   choices   { [prefix + key]: 'existing' | 'new' }
 * @param {string}   prefix    'company.' eller 'contact.'
 * @param {Function} onChoose  (choiceKey, value) => void
 */
export default function MergeChoices({ rows, choices, prefix, onChoose }) {
  if (!rows.length) {
    return (
      <Typography variant="caption" color="text.secondary">
        Inga nya uppgifter — allt som tolkades finns redan.
      </Typography>
    );
  }
  const fills = rows.filter(r => r.kind === 'fill');
  const conflicts = rows.filter(r => r.kind === 'conflict');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {fills.length > 0 && (
        <Box>
          <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            Tomma fält som fylls i
          </Typography>
          {fills.map(r => (
            <Typography key={r.key} variant="body2" sx={{ fontSize: '0.8rem' }}>
              <Box component="span" sx={{ color: 'text.secondary', mr: 1 }}>{r.label}:</Box>{r.next}
            </Typography>
          ))}
        </Box>
      )}
      {conflicts.length > 0 && (
        <Box>
          <Typography variant="caption" fontWeight="bold" color="#E65100" sx={{ display: 'block', mb: 0.5 }}>
            Avvikande värden — välj vilket som ska gälla
          </Typography>
          {conflicts.map(r => (
            <Box key={r.key} sx={{ mb: 0.5 }}>
              <Typography variant="caption" color="text.secondary">{r.label}</Typography>
              <RadioGroup row value={choices[prefix + r.key] || 'existing'}
                onChange={e => onChoose(prefix + r.key, e.target.value)}>
                <FormControlLabel value="existing" control={<Radio size="small" />}
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>Behåll: {r.current}</Typography>} />
                <FormControlLabel value="new" control={<Radio size="small" />}
                  label={<Typography variant="body2" sx={{ fontSize: '0.8rem' }}>Byt till: {r.next}</Typography>} />
              </RadioGroup>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

/** Plockar ut de värden som ska skrivas utifrån planen och användarens val. */
export function pickUpdates(rows, choices, prefix) {
  return Object.fromEntries(
    rows
      .filter(r => r.kind === 'fill' || choices[prefix + r.key] === 'new')
      .map(r => [r.key, r.next])
  );
}
